import api from '../../utils/axios';

// Constants
import { API_ROUTES } from '../../constants/apiRoutes';
import { Status } from '../../constants/common';

export const getJobsListApi = async ({
  pageNumber,
  searchValue,
  sortBy,
  orderBy,
  size,
  technologies,
  minExp,
  maxExp,
  jobMode,
  status
}) => {
  try {
    let url = `${API_ROUTES.JOBS}?page=${pageNumber || 1}&searchName=${searchValue || ''}&sortBy=${
      sortBy || 'DateModified'
    }&orderBy=${orderBy || 'desc'}&size=${size || 10}`;
    if (technologies) {
      const techVal = Array.isArray(technologies) ? technologies.join(',') : technologies;
      if (techVal) {
        url += `&technologies=${techVal}`;
      }
    }
    if (minExp !== null && minExp !== undefined && minExp !== '') {
      url += `&minExp=${minExp}`;
    }
    if (maxExp !== null && maxExp !== undefined && maxExp !== '') {
      url += `&maxExp=${maxExp}`;
    }
    if (jobMode) {
      url += `&jobMode=${jobMode}`;
    }
    if (status !== null && status !== undefined && status !== '') {
      url += `&status=${status}`;
    }
    const response = await api.get(url);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getJobByIdApi = async (ID) => {
  try {
    const response = await api.get(`${API_ROUTES.JOBS}/${ID}`);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const addJobApi = async (job) => {
  try {
    const response = await api.post(API_ROUTES.JOBS, job);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const editJobApi = async (details) => {
  try {
    const response = await api.put(`${API_ROUTES.JOBS}/${details.ID}`, details.payload);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const deleteJobApi = async (ID) => {
  try {
    const response = await api.delete(`${API_ROUTES.JOBS}/${ID}`);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const jobStatusApi = async (payload) => {
  try {
    const isActivating =
      payload.Status === 1 || payload.Status === true || payload.Status === Status.Active;
    const response = await api.put(`${API_ROUTES.JOB_STATUS}/${payload.id}`, {
      Status: isActivating ? Status.Active : Status.Inactive,
      ...(payload.hrIds !== undefined && { hrIds: payload.hrIds })
    });
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getJobHrTimelineApi = async (ID) => {
  try {
    const response = await api.get(`${API_ROUTES.JOB_HR_TIMELINE}/${ID}`);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getJobHrAssignmentsApi = async (jobId) => {
  try {
    const response = await api.get(`${API_ROUTES.JOBS}/${jobId}/hr-assignments`);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const assignJobHrApi = async (payload) => {
  try {
    const response = await api.post(API_ROUTES.JOB_HR_ASSIGN, payload);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getSingleJobHrAssignmentApi = async (ID) => {
  try {
    const response = await api.get(`${API_ROUTES.JOB_HR_ASSIGN}/${ID}`);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const updateJobHrAssignmentDurationApi = async (ID, payload) => {
  try {
    const response = await api.put(`${API_ROUTES.JOB_HR_ASSIGN}/${ID}`, payload);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const relieveJobHrAssignmentApi = async (ID) => {
  try {
    const response = await api.delete(`${API_ROUTES.JOB_HR_ASSIGN}/${ID}`);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};
